<template>
  <v-container>
    <v-row justify="center">
      <v-card
        style="width: 1024px; height: 600px"
        id="app-preview"
        class="d-flex flex-column"
      >
        <v-app-bar :color="primaryColor" :dark="darkTheme" class="flex-grow-0">
          <info-dialog class="mr-3"></info-dialog>
        </v-app-bar>
        <v-container class="flex-grow-1">
          <v-row justify="center" align="center" style="height: 100%">
            <v-col md="4" lg="3" class="text-center">
              <v-card :class="!darkTheme ? 'grey darken-1' : ''">
                <v-icon :color="primaryColor" size="180px"
                  >mdi-application</v-icon
                >
              </v-card>
              <div class="text-h5 mt-5">{{ $t("My application") }}</div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import InfoDialog from "@/components/InfoDialog";

export default {
  name: "CustomizationAppPreview",
  components: { InfoDialog },
  computed: {
    ...mapState({
      editedItem: (state) => state.customizations.editedItem,
      primaryColor: (state) => state.customizations.primaryColor,
      darkTheme: (state) => state.customizations.editedItem.dark_theme,
    }),
  },
};
</script>